<div class="d-flex flex-column gap-3">
    <ng-container *ngIf="!details">
        <app-spinner></app-spinner>
    </ng-container>

    <ng-container *ngIf="details && areDetailsVisible">
        <h1>{{details.subject}}</h1>
        <div [innerHTML]="details.contentLong"></div>
    </ng-container>

    <div class="d-flex gap-3 flex-md-row flex-column">
        <div>
            <a class="btn btn-default w-100" href="/">{{'Zur Startseite' | transloco}}</a>
        </div>

        <div *ngIf="actionLinkUrl != null && actionLinkText">
            <a class="btn btn-default w-100" [href]="actionLinkUrl">{{actionLinkText}}</a>
        </div>
    </div>
</div>